import { z } from 'zod';
import { uuidSchema } from './common';

export const resourceTypeSchema = z.enum(['budget', 'payment_card', 'transaction']);
export type ResourceType = z.infer<typeof resourceTypeSchema>;

export const permissionFlagsSchema = z.object({
  canView: z.boolean().default(false),
  canAdd: z.boolean().default(false),
  canEdit: z.boolean().default(false),
  canDelete: z.boolean().default(false),
});
export type PermissionFlags = z.infer<typeof permissionFlagsSchema>;

export const setPermissionSchema = z.object({
  resourceType: resourceTypeSchema,
  resourceId: uuidSchema,
  ...permissionFlagsSchema.shape,
});
export type SetPermissionInput = z.infer<typeof setPermissionSchema>;

export const bulkSetPermissionsSchema = z.object({
  permissions: z.array(setPermissionSchema).min(1),
});
export type BulkSetPermissionsInput = z.infer<typeof bulkSetPermissionsSchema>;
